import { render, staticRenderFns } from "./uploadPage.vue?vue&type=template&id=c7afc48e&scoped=true&"
import script from "./uploadPage.vue?vue&type=script&lang=js&"
export * from "./uploadPage.vue?vue&type=script&lang=js&"
import style0 from "./uploadPage.vue?vue&type=style&index=0&id=c7afc48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7afc48e",
  null
  
)

export default component.exports